export const LOCAL_STORAGE_KEY_IS_THEME_DARK = 'isThemeDark'
